import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const GenerationOptionsPanel = ({ 
  formData, 
  onFormDataChange, 
  onGenerate, 
  onPrint,
  isGenerating 
}) => {
  const paperSizeOptions = [
    { value: 'a4', label: 'A4' },
    { value: 'letter', label: 'Letter' },
    { value: 'legal', label: 'Legal' }
  ];

  const orientationOptions = [
    { value: 'portrait', label: 'عمودي' },
    { value: 'landscape', label: 'أفقي' }
  ];

  const formatOptions = [
    { value: 'pdf', label: 'PDF' },
    { value: 'word', label: 'Word' },
    { value: 'excel', label: 'Excel' }
  ];

  return (
    <div className="h-full flex flex-col bg-card border-r border-border">
      <div className="p-4 md:p-6 border-b border-border">
        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground flex items-center gap-2">
          <Icon name="Settings" size={20} />
          خيارات الإنشاء
        </h3>
      </div>
      <div className="flex-1 overflow-auto p-4 md:p-6 space-y-4 md:space-y-6">
        <div>
          <h4 className="text-sm font-heading font-semibold text-foreground mb-3">
            إعدادات الطباعة
          </h4>
          <div className="space-y-3">
            <Select
              label="حجم الورق"
              options={paperSizeOptions}
              value={formData?.paperSize || 'a4'}
              onChange={(value) => onFormDataChange({ ...formData, paperSize: value })}
            />
            <Select
              label="الاتجاه"
              options={orientationOptions}
              value={formData?.orientation || 'portrait'}
              onChange={(value) => onFormDataChange({ ...formData, orientation: value })}
            />
          </div>
        </div>

        <div>
          <h4 className="text-sm font-heading font-semibold text-foreground mb-3">
            تنسيق الملف
          </h4>
          <Select
            label="نوع الملف"
            options={formatOptions}
            value={formData?.format || 'pdf'}
            onChange={(value) => onFormDataChange({ ...formData, format: value })}
          />
        </div>

        <div>
          <h4 className="text-sm font-heading font-semibold text-foreground mb-3">
            خيارات إضافية
          </h4>
          <div className="space-y-3">
            <Checkbox
              label="تضمين الشعار"
              checked={formData?.includeLogo || false}
              onChange={(e) => onFormDataChange({ ...formData, includeLogo: e?.target?.checked })}
            />
            <Checkbox
              label="تضمين التوقيع الإلكتروني"
              checked={formData?.includeSignature || false}
              onChange={(e) => onFormDataChange({ ...formData, includeSignature: e?.target?.checked })}
            />
            <Checkbox
              label="إضافة رقم المرجع"
              checked={formData?.includeReference || false}
              onChange={(e) => onFormDataChange({ ...formData, includeReference: e?.target?.checked })}
            />
            <Checkbox
              label="إضافة الطابع الزمني"
              checked={formData?.includeTimestamp || false}
              onChange={(e) => onFormDataChange({ ...formData, includeTimestamp: e?.target?.checked })}
            />
          </div>
        </div>

        <div>
          <h4 className="text-sm font-heading font-semibold text-foreground mb-3">
            عدد النسخ
          </h4>
          <Input
            type="number"
            label="عدد النسخ"
            min={1}
            max={10}
            value={formData?.copies || 1}
            onChange={(e) => onFormDataChange({ ...formData, copies: parseInt(e?.target?.value) || 1 })}
          />
        </div>

        <div>
          <h4 className="text-sm font-heading font-semibold text-foreground mb-3">
            التوزيع
          </h4>
          <div className="space-y-3">
            <Checkbox
              label="إرسال عبر البريد الإلكتروني"
              checked={formData?.sendEmail || false}
              onChange={(e) => onFormDataChange({ ...formData, sendEmail: e?.target?.checked })}
            />
            <Checkbox
              label="إرسال عبر واتساب"
              checked={formData?.sendWhatsApp || false}
              onChange={(e) => onFormDataChange({ ...formData, sendWhatsApp: e?.target?.checked })}
            />
            <Checkbox
              label="حفظ في الأرشيف"
              checked={formData?.saveToArchive || true}
              onChange={(e) => onFormDataChange({ ...formData, saveToArchive: e?.target?.checked })}
            />
          </div>
        </div>
      </div>
      <div className="p-4 md:p-6 border-t border-border space-y-3">
        <Button
          variant="default"
          fullWidth
          iconName="FileText"
          iconPosition="right"
          onClick={onGenerate}
          loading={isGenerating}
        >
          إنشاء المستند
        </Button>
        <Button
          variant="outline"
          fullWidth
          iconName="Printer"
          iconPosition="right"
          onClick={onPrint}
        >
          طباعة مباشرة
        </Button>
        <Button
          variant="ghost"
          fullWidth
          iconName="Download"
          iconPosition="right"
        >
          تحميل القالب
        </Button>
      </div>
    </div>
  );
};

export default GenerationOptionsPanel;